<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import FallbackAvatar from '@/components/ui/FallbackAvatar'

  export default {
    name: 'UserItems',
    components: {
      FallbackAvatar,
    },
    props: {
      members: Object,
      showResend: Boolean,
      showRemove: Boolean,
    },
  }
</script>

